export default __webpack_public_path__ + "img/66a0efecd73693ea17ad909cb7bcf1f9.png";